import { render, staticRenderFns } from "./productDataDetails.vue?vue&type=template&id=85c3b234&scoped=true"
import script from "./productDataDetails.vue?vue&type=script&lang=js"
export * from "./productDataDetails.vue?vue&type=script&lang=js"
import style0 from "./productDataDetails.vue?vue&type=style&index=0&id=85c3b234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c3b234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85c3b234')) {
      api.createRecord('85c3b234', component.options)
    } else {
      api.reload('85c3b234', component.options)
    }
    module.hot.accept("./productDataDetails.vue?vue&type=template&id=85c3b234&scoped=true", function () {
      api.rerender('85c3b234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/toAuditAndDataQueryDetails/productDataDetails.vue"
export default component.exports